import { render, staticRenderFns } from "./_ticketList.vue?vue&type=template&id=280acb89&lang=pug"
import script from "./_ticketList.vue?vue&type=script&lang=js"
export * from "./_ticketList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports